module.exports = __webpack_public_path__ + "static/media/data_meet_matt.3f0076c3.png";